import classNames from "classnames";
import React from "react";

import { Background, BACKGROUNDS, Color, COLORS } from "../consts";
import Icon, { IconType } from "../Icon";
import styles from "./IconInCircle.module.scss";

type Props = {
  icon: IconType;
  size?: "xlarge" | "xxlarge";
  color?: Color;
  background?: Background;
};

export default function IconInCircle({ icon, size, color, background }: Props) {
  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.backgroundLightBlue]: background === BACKGROUNDS.LIGHT_BLUE,
        [styles.sizeXLarge]: size === "xlarge",
        [styles.sizeXXLarge]: size === "xxlarge"
      })}
    >
      <Icon
        icon={icon}
        className={classNames(styles.icon, {
          [styles.colorBlue]: color === COLORS.BLUE
        })}
      />
    </div>
  );
}
